
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","stroke-width":"2","d":"M16 4h9"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-width":"2","d":"M0 4h13"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-width":"2","d":"M6 25v-7"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-width":"2","d":"M21 16V9"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-width":"2","d":"M16 7V0"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-width":"2","d":"M21 13h4"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-width":"2","d":"M0 13h18"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-width":"2","d":"M9 22h16"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-width":"2","d":"M0 22h6"}})])
          )
        }
      }
    